import type { TAnnouncementAudience } from '@src/shared/types/announcement';

export type { TAnnouncementAudience };

export const ANNOUNCEMENT_STATIC_AUDIENCE_OPTIONS: {
  key: Exclude<TAnnouncementAudience, 'PROGRAMS'>;
  label: string;
}[] = [
  { key: 'ALL', label: 'All (Participants and Leads)' },
  { key: 'LEADS', label: 'All Leads only' },
  { key: 'PARTICIPANTS', label: 'All Participants only' },
];

export type TAnnouncementShareToProgram = {
  id: number;
  name: string;
};

export function getShareToDisplayLabel(
  audience: TAnnouncementAudience | '',
  programs: TAnnouncementShareToProgram[]
): string {
  if (!audience) return 'Select Audience';

  if (audience === 'PROGRAMS') {
    if (!programs.length) return 'Select Audience';
    if (programs.length <= 2) {
      return programs.map((program) => program.name).join(', ');
    }
    return `${programs.length} programs selected`;
  }

  return (
    ANNOUNCEMENT_STATIC_AUDIENCE_OPTIONS.find((option) => option.key === audience)
      ?.label ?? 'Select Audience'
  );
}

export function buildAnnouncementAudiencePayload(values: {
  audience: TAnnouncementAudience | '';
  shareToPrograms: TAnnouncementShareToProgram[];
}) {
  if (values.audience === 'PROGRAMS') {
    return {
      audience: 'PROGRAMS' as const,
      programs: values.shareToPrograms.map((program) => program.id),
    };
  }

  return {
    audience: values.audience as Exclude<TAnnouncementAudience, 'PROGRAMS'>,
  };
}
